import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { escapeElement } from "./escape-element";
export var XmlText = /*#__PURE__*/function () {
  function XmlText(value) {
    _classCallCheck(this, XmlText);
    this.value = value;
  }
  _createClass(XmlText, [{
    key: "toString",
    value: function toString() {
      return escapeElement("" + this.value);
    }
  }]);
  return XmlText;
}();